<template >
    <el-dialog title="用户地址" :visible.sync="showModal" width="32%" :close-on-click-modal="false" :destroy-on-close="true">
        <el-form ref="form" :model="addressData" label-width="100px">
            <el-form-item label="收件人">
                <el-input v-model="addressData.user_name" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="电话">
                <el-input v-model="addressData.user_phone" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="邮编">
                <el-input v-model="addressData.postal_code" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="收货详细区">
                <el-input v-model="addressData.address_details" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="$emit('update:show', false)">确定</el-button>
                <el-button @click="copyAddress">复制地址</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
export default {
    data: () => ({}),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        // 用户ID
        id: String | Number,
        addressData: {
            type: Object,
            default: () => { }
        }
    },
    methods: {
        trunOff() {
            this.showModal = false
        },
        async copyAddress() {
            const { user_name, user_phone, postal_code, address_details } = this.addressData

            // let aux = document.createElement("input");
            // aux.setAttribute("value", `${name}-${phone}-${postalCode}-${province}-${fullAddress}`);
            // document.body.appendChild(aux);
            // aux.select();
            // document.execCommand("copy");
            // this.$message({
            //     message: '已复制到剪贴板',
            //     type: 'success'
            // });
            // document.body.removeChild(aux);
            try {
                await this.$copyText(`${user_name}-${user_phone}-${postal_code}-${address_details}`)
                this.$message({
                    message: '复制剪贴板成功',
                    type: 'success'
                })
            } catch (err) {
                console.log(err)
                this.$message({
                    message: '复制失败',
                    type: 'warning'
                })
            }
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
    }
}
</script>

<style lang="scss" scoped></style>